<template>
  <div class="fixed-container" :style="customStyle">
    <div class="publish-item" v-if="$route.name === 'wikiList'" title="发稿" @click="handleItem('editor')">
      <img class="publish-btn" src="@/assets/images/publish-article-btn.png" alt="" />
      <span class="word">发帖</span>
    </div>
    <div v-if="$route.name === 'wikiHome'" class="fixed-item" @click="handleItem('editor')" title="攻略创作">
      <i class="wiki-icon wiki-icon-game-guide"></i>
    </div>
    <div v-if="$route.name === 'wikiHome'" class="fixed-item" @click="handleItem('question')" title="社区提问">
      <i class="wiki-icon wiki-icon-question"></i>
    </div>
    <div v-if="$route.name !== 'wikiDetail'" class="fixed-item" @click="handleItem('share')" title="分享">
      <i class="iconfont icon-fenxiang"></i>
    </div>
    <!--<div v-if="$route.name !== 'wikiDetail'" class="fixed-item" @click="$emit('reward')" title="赞赏">
      <i style="font-size: 26px;" class="icon zsicon icon-study_bounty-"></i>
    </div>-->
    <div class="fixed-item" v-if="hasScroll" @click="handleItem('top')" title="回到顶部">
      <i class="wiki-icon wiki-icon-top"></i>
    </div>
  </div>
</template>
<script>
import eventBus from "@/plugins/eventBus";
import Clipboard from "clipboard";
import calcMixin from "@/mixins/calcMixin";
import { mapGetters } from "vuex";

export default {
  name: "fixedShare",
  mixins: [calcMixin],
  props: {
    customStyle: {
      type: Object,
      default: () => ({})
    },
    // 从文章处传过来的文章id
    from: {
      type: String,
      default: ""
    },
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // wiki首页文章id
      currentId: "",
      // wiki首页文章详情
      currentDetail: null,
      hasScroll: false
    };
  },
  computed: {
    ...mapGetters(["gameInfo"])
  },
  methods: {
    handleItem(type) {
      if (type === "top") {
        this.leftScrollTop();
        this.rightScrollTop();
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      } else if (type === "share") {
        let shareText = "";
        if (this.from === "detail" && this.detail) {
          shareText = `${this.detail.user.username}分享了文章:${this.detail.title}\r\n`;
          shareText += window.location.href + "\r\n";
          shareText += "来自GameKee";
        } else if (this.currentDetail) {
          shareText = `${this.currentDetail.user.username}分享了文章:${this.currentDetail.title}\r\n`;
          shareText +=
            `${window.location.origin}/${this.currentDetail.game.alias}/${this.currentDetail.id}.html` + "\r\n";
          shareText += "来自GameKee";
        } else {
          shareText = window.location.href;
        }
        let $div = document.createElement("div");
        $div.setAttribute("data-clipboard-text", shareText);
        $div.classList.add("page-share-copy-btn");
        document.body.appendChild($div);
        let clipboard = new Clipboard(".page-share-copy-btn");
        clipboard.on("success", e => {
          this.$message("复制成功！");
          document.body.removeChild($div);
          clipboard.destroy();
        });
        clipboard.on("error", e => {
          // 不支持复制
          this.$message("浏览器不支持自动复制,请更换其他浏览器");
          document.body.removeChild($div);
          clipboard.destroy();
        });
        $div.click();
      } else if (type === "editor") {
        this.goEdit();
      } else if (type === "question") {
        this.$emit("openQuestion");
      }
    },
    goEdit() {
      if (!this.isLoginShow("")) {
        sessionStorage.setItem("login_jump_path", `/${this.gameInfo.alias}/editor`);
        return false;
      }
      if (!this.isAuthRealName()) {
        sessionStorage.setItem("login_jump_path", `/${this.gameInfo.alias}/editor`);
        return false;
      }
      this.$router.push(`/${this.gameInfo.alias}/editor`);
    },
    handleScroll() {
      const winScrollTop = window.document.documentElement.scrollTop || window.document.body.scrollTop;
      const leftScroll = document.getElementById("leftScroll");
      const rightScroll = document.getElementById("rightScroll");
      if (winScrollTop > 0 || (leftScroll && leftScroll.scrollTop > 0) || (rightScroll && rightScroll.scrollTop > 0)) {
        this.hasScroll = true;
      } else {
        this.hasScroll = false;
      }
    }
  },
  mounted() {
    const leftScroll = document.getElementById("leftScroll");
    const rightScroll = document.getElementById("rightScroll");
    eventBus.$on("getDetail", val => {
      this.currentId = val;
    });
    eventBus.$on("setDetailInfos", val => {
      this.currentDetail = val;
    });
    eventBus.$on("setDetailBoxVisible", visible => {
      if (!visible) {
        this.currentId = "";
        this.currentDetail = null;
      }
    });
    window.addEventListener("scroll", this.handleScroll);
    if (leftScroll) {
      leftScroll.addEventListener("scroll", this.handleScroll);
    }
    if (rightScroll) {
      rightScroll.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    const leftScroll = document.getElementById("leftScroll");
    const rightScroll = document.getElementById("rightScroll");
    window.removeEventListener("scroll", this.handleScroll);
    if (leftScroll) {
      leftScroll.removeEventListener("scroll", this.handleScroll);
    }
    if (rightScroll) {
      rightScroll.removeEventListener("scroll", this.handleScroll);
    }
  }
};
</script>
<style lang="less" scoped>
.fixed-container {
  position: fixed;
  display: flex;
  bottom: 130px;
  left: 50%;
  margin-left: 690px;
  flex-direction: column;
  .fixed-item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    width: 48px;
    height: 48px;
    color: #999;
    font-size: 24px;
    background-color: #fff;
    border-radius: 8px;
    transition: all ease 0.3s;
    cursor: pointer;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .publish-item {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    width: 48px;
    height: 48px;
    background-color: transparent;
    // margin-left: -11px;
    cursor: pointer;
    .word {
      position: absolute;
      bottom: 5px;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
      font-size: 12px;
    }
    .publish-btn {
      width: 48px;
      height: 48px;
    }
  }
}
</style>
